<template>
  <el-row>
    <el-cascader
      v-model="regionValue"
      :options="regionList"
      :props="{ expandTrigger: 'hover' }"
      :style="{ width: width + 'px' }"
      placeholder="请选择省市区"
      :disabled="disabled"
    >
      <template #default="{ data }">
        <span>{{ data.label }}</span>
      </template>
    </el-cascader>
  </el-row>
</template>

<script lang="ts" setup>
import { onMounted, getCurrentInstance, watch, ref, Ref } from "vue";
import { regionTree } from "@/api/api";

const props = defineProps({
  value: {
    type: Object,
    default() {
      return {};
    },
  },
  width: {
    type: Number,
    default: 400,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isRegionStr: {
    //格式:是否是"北京市,北京市,东城区"格式
    type: Boolean,
    default: false,
  },
  regionStr: {
    //格式: "北京市,北京市,东城区"
    type: String,
    default: "",
  },
});

const regionList: Ref<any[]> = ref([]);
const regionValue: Ref<any[]> = ref([]);

const emits = defineEmits<{
  (e: "update:value", obj: any): void;
}>();

const app = getCurrentInstance()?.proxy;

onMounted(async () => {
  const res = await regionTree();
  if (res.code == 200) {
    regionList.value = res.data;
    if (props.isRegionStr && props.regionStr) {
      regionList.value.forEach((item) => {
        item.children.forEach(
          (subItem: { children: any[]; label: string; value: any }) => {
            subItem.children.forEach((lower: { label: string; value: any }) => {
              const regionLabel =
                item.label + "," + subItem.label + "," + lower.label;
              if (props.regionStr === regionLabel) {
                regionValue.value = [item.value, subItem.value, lower.value];
              }
            });
          }
        );
      });
    } else {
      if (props.value.province_id) {
        regionValue.value = [
          props.value.province_id,
          props.value.city_id,
          props.value.county_id,
        ];
      }
    }
  } else {
    app?.$message.error(res.message);
  }
});

const setRegionValue = (data: number[]) => {
  regionValue.value = data;
};

watch(
  regionValue,
  (newVal) => {
    try {
      let province = {} as { children: any[]; label: any };
      if (!newVal[0]) {
        return;
      }
      regionList.value.forEach((item) => {
        if (item.value === regionValue.value[0]) {
          province = item;
        }
      });
      let city = {} as { children: any[]; label: any };
      province.children.forEach((item) => {
        if (item.value === regionValue.value[1]) {
          city = item;
        }
      });
      let county = {} as { children: any[]; label: any };
      city.children.forEach((item) => {
        if (item.value === regionValue.value[2]) {
          county = item;
        }
      });
      if (props.isRegionStr) {
        const regionLabel =
          province.label + "," + city.label + "," + county.label;
        emits("update:value", regionLabel);
      } else {
        emits("update:value", {
          province_id: regionValue.value[0],
          city_id: regionValue.value[1],
          county_id: regionValue.value[2],
          province_name: province.label,
          city_name: city.label,
          county_name: county.label,
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  { deep: true }
);

defineExpose({
  setRegionValue,
});
</script>
<style lang="scss" scoped></style>
